import { httpRequest } from '@/utils/request';
import { CommonResponse, TableReponseType } from '@/types';

export interface DeviceProperty {
  type_spec?: any;
  value: number;
  time: number;
  code: string;
  data_type: string;
  unit: string;
  name: string;
  access_mode: 'RW' | 'R' | 'rw' | 'ro';
}

export function getDeviceProperty({ id, page, pageSize, info, tag }: { id: string; page: number; pageSize: number; info?: string; tag?: string }) {
  return httpRequest<any, CommonResponse<TableReponseType<DeviceProperty>>>({
    url: `/api/v1/device/${id}/thing-model/property?last=true&page=${page}&pageSize=${pageSize}&info=${info || ''}&tag=${tag || ''}`,
  });
}

export interface ReportDaum {
  value: number;
  time: number;
}

export interface HistoryProperty {
  list: ReportDaum[];
  code: string;
  data_type: string;
  unit: string;
  name: string;
  access_mode: string;
}

export function getHistoryProperty<T>(
  id: string,
  data: {
    code: string;
    start: number;
    end: number;
    page?: number;
    pageSize?: number;
    isAll?: boolean;
    aggregateTime?: string;
    aggregateMethod?: string;
  },
) {
  let url = `/api/v1/device/${id}/thing-model/history-property?code=${data.code}&range=${data.start}&range=${data.end}`;
  if (data.page !== undefined) {
    url += `&page=${data.page}`;
  }
  if (data.pageSize !== undefined) {
    url += `&pageSize=${data.pageSize}`;
  }
  if (data.aggregateTime) {
    url += `&aggregateTime=${data.aggregateTime}`;
  }
  if (data.aggregateMethod) {
    url += `&aggregateMethod=${data.aggregateMethod}`;
  }
  return httpRequest<any, CommonResponse<T>>({
    url,
  });
}

export function getHistoryPropertyAll<T>(
  id: string,
  data: {
    code: string;
    start: number;
    end: number;
    aggregateTime?: string;
    aggregateMethod?: string;
  },
) {
  let url = `/api/v1/device/${id}/thing-model/history-property?code=${data.code}&range=${data.start}&range=${data.end}&isAll=true`;
  if (data.aggregateTime) {
    url += `&aggregateTime=${data.aggregateTime}`;
  }
  if (data.aggregateMethod) {
    url += `&aggregateMethod=${data.aggregateMethod}`;
  }
  return httpRequest<any, CommonResponse<T>>({
    url,
  });
}

export interface DeviceEventRequestType {
  id: string;
  eventCode: string;
  start: number;
  end: number;
  // eventType: 'info' | 'alert' | 'error' | ''
  page?: number;
  pageSize?: number;
}

export interface DeviceEvent {
  event_code: string;
  event_type: string;
  report_time: number;
  name: string;
  output_data: {
    Data: string;
    Data2: number;
  };
}

export function getDeviceEvent<T>({ id, eventCode, start, end, page, pageSize }: DeviceEventRequestType) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/device/${id}/thing-model/event?eventCode=${eventCode}&range=${start}&range=${end}&page=${page}&pageSize=${pageSize}`,
  });
}

export interface DeviceServiceRequestType {
  id: string;
  code: string;
  start: number;
  end: number;
  page?: number;
  pageSize?: number;
}

export interface DeviceService {
  report_time: number;
  code: string;
  service_name: string;
  input_data: {
    ForceDelete: number;
  };
  output_data: {
    code: number;
    message: string;
  };
}

export function getDeviceService<T>({ id, code, start, end, page, pageSize }: DeviceServiceRequestType) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/device/${id}/thing-model/service?code=${code}&range=${start}&range=${end}&page=${page}&pageSize=${pageSize}`,
  });
}

export function deviceControl(data: { deviceId: string; data: { [key: string]: boolean } }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device/control',
    method: 'post',
    data,
  });
}

// 设备属性设置（不需要设备在线，仅存DB+非阻塞MQTT）
export function devicePropertySet(data: { deviceId: string; data: { [key: string]: string | number | boolean } }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device/property/set',
    method: 'post',
    data,
  });
}

// Chart history property types
export interface ReportDatum {
  time: number;
  value: number;
  [property: string]: any;
}

export interface ChartHistoryPropertyList {
  code: string;
  device_id: string;
  name: string;
  report_data: ReportDatum[] | null;
  [property: string]: any;
}

export interface ChartHistoryPropertyResult {
  list: ChartHistoryPropertyList[];
  page: number;
  pageSize: number;
  total: number;
  [property: string]: any;
}

export function getChartHistoryProperty(id: string) {
  return httpRequest<any, CommonResponse<ChartHistoryPropertyResult>>({
    url: `/api/v1/device/${id}/thing-model/chart/history-property`,
    method: 'get',
  });
}

export function getChartHistoryPropertyWithParams(
  id: string,
  data: {
    start: number;
    end: number;
    page?: number;
    pageSize?: number;
    aggregateTime?: string;
    aggregateMethod?: string;
  },
) {
  let url = `/api/v1/device/${id}/thing-model/chart/history-property?range=${data.start}&range=${data.end}`;
  if (data.page !== undefined) {
    url += `&page=${data.page}`;
  }
  if (data.pageSize !== undefined) {
    url += `&pageSize=${data.pageSize}`;
  }
  if (data.aggregateTime) {
    url += `&aggregateTime=${data.aggregateTime}`;
  }
  if (data.aggregateMethod) {
    url += `&aggregateMethod=${data.aggregateMethod}`;
  }
  return httpRequest<any, CommonResponse<ChartHistoryPropertyResult>>({
    url,
    method: 'get',
  });
}